import React from 'react';
import { HeroSection } from './HeroSection';
import { TrustBar } from './TrustBar';
import { ServicesGrid } from './ServicesGrid';
import { AIHighlight } from './AIHighlight';
import { CommonProblems } from './CommonProblems';
import { ProjectManagement } from './ProjectManagement';
import { HomeCTA } from './HomeCTA';
import { SEOAccordions } from './SEOAccordions';
export function Home() {
  return <div className="min-h-screen w-full bg-background" data-id="element-317">
      <HeroSection data-id="element-318" />
      <TrustBar data-id="element-319" />
      <ServicesGrid data-id="element-320" />
      <AIHighlight data-id="element-321" />
      <CommonProblems data-id="element-322" />
      <ProjectManagement data-id="element-323" />
      <HomeCTA data-id="element-324" />
      <SEOAccordions data-id="element-325" />
    </div>;
}